import React from "react";
import "./styles.scss";

import pageImg3 from "../../../assets/images/welcomepages/Page3/pg3.png";
import one from "../../../assets/images/welcomepages/Page3/one.png";
import two from "../../../assets/images/welcomepages/Page3/two.png";
import three from "../../../assets/images/welcomepages/Page3/three.png";
import four from "../../../assets/images/welcomepages/Page3/four.png";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";

function Page3() {
  const navigate = useNavigate();
  const goToNextPage = () => {
    navigate("/welcome/profile-details");
  };

  return (
    <div className="page3-cont">
      <div className="left">
        <img src={pageImg3} alt="" />
      </div>
      <div className="right">
        <h1 className="section-heading">
          What you need to know before starting with us
        </h1>
        {/* <h3 className='section-sub-heading'>
                    What you need to know before starting with us
                </h3> */}
        <p className="step-heading">
          Your success on AerialBorne is important to us. Avoid the following to
          keep in line with our community standards:
        </p>

        <ul className="list">
          <li className="list-item">
            <div className="list-icon">
              <img src={one} alt="" />
            </div>
            <div className="list-data">
              <p>
                Providing any misleading or inaccurate information about your
                identity.
              </p>
            </div>
          </li>

          <li className="list-item">
            <div className="list-icon">
              <img src={two} alt="" />
            </div>
            <div className="list-data">
              <p>
                Opening duplicate accounts. Remember, you can always create more
                Gigs.
              </p>
            </div>
          </li>

          <li className="list-item">
            <div className="list-icon">
              <img src={three} alt="" />
            </div>
            <div className="list-data">
              <p>Soliciting other community members for work on AerialBorne.</p>
            </div>
          </li>

          <li className="list-item">
            <div className="list-icon">
              <img src={four} alt="" />
            </div>
            <div className="list-data">
              <p>
                Requesting to take communication and payment outside of
                AerialBorne.
              </p>
            </div>
          </li>
        </ul>

        <div className="btn-container">
          <Button
            label={"Yes I'm in"}
            handleClick={goToNextPage}
            customStyle={{ backgroundColor: "#08742C", color: "white",padding:"10px 60px" }}
          />
        </div>
      </div>
    </div>
  );
}

export default Page3;
